import React, { ReactNode } from "react";
import background from "../../assets/Images/Onaboarding-BGCompressed.png";

type OnboardingBackgroundProps = {
  children: ReactNode;
};

const OnboardingBackground = ({ children }: OnboardingBackgroundProps) => {
  return (
    <div
      className="flex justify-center items-center min-h-screen w-full font-gully"
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
      key='onboardingBackground'
    >
      {children}
    </div>
  );
};

export default OnboardingBackground;
